import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { useGetQuickbooksConnection } from "@/business/quickbooks-query";
import { useConnectQuickbooks } from "@/business/use-connect-quickbooks";
import { useQuickbooksAccess } from "./use-quickbooks-access";

/**
 * A slim warning across the top of AP while QuickBooks refuses Volca's
 * connection. Bills wait rather than fail, so the fix is a reconnect.
 */
export const QuickbooksReconnectBanner = () => {
  const { businessId, isVisible, canManage } = useQuickbooksAccess();
  const { data: connection } = useGetQuickbooksConnection(businessId, {
    enabled: isVisible,
  });
  const { connect, isPending } = useConnectQuickbooks(businessId);

  if (!isVisible || connection?.status !== "needs_reconnect") return null;

  return (
    <Alert color="warning" role="status" className="mb-4 items-center py-2">
      <WarningIcon />
      <AlertDescription>
        <Stack
          className="w-full"
          direction="row"
          align="center"
          justify="between"
          gap={4}
        >
          <Text>
            QuickBooks stopped accepting Volca’s connection. Bills are paused
            until someone reconnects
            {canManage ? "." : ". Ask a manager or admin to reconnect it."}
          </Text>
          {canManage && (
            <Button
              size="sm"
              variant="secondary"
              className="flex-none"
              disabled={isPending}
              loading={isPending}
              onClick={() => void connect()}
            >
              Reconnect QuickBooks
            </Button>
          )}
        </Stack>
      </AlertDescription>
    </Alert>
  );
};
